__turbopack_context__.v({
  "pagination": "PlpPagination-module-scss-module__YKpMXW__pagination",
});
